import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations'
import { CommonModule } from '@angular/common'
import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { Subscription } from 'rxjs'
import { DdcAddDialogComponent } from 'src/app/core/ddc-add-dialog/ddc-add-dialog.component'
import {
  NodeConfigDialogComponent,
  NodeConfigDialogResult,
} from 'src/app/core/ddc-canvas/node-config-dialog/node-config-dialog.component'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'
import { DdcAddMobileSheetComponent } from '../ddc-add-mobile-sheet/ddc-add-mobile-sheet.component'
import { DdcEditMobileSheetComponent } from '../ddc-edit-mobile-sheet/ddc-edit-mobile-sheet.component'
import { DdcFilterMobileSheetComponent } from '../ddc-filter-mobile-sheet/ddc-filter-mobile-sheet.component'
import { DdcGeneratePdfMobileSheetComponent } from '../ddc-generate-pdf-mobile-sheet/ddc-generate-pdf-mobile-sheet.component'
import { DdcReadFigureMobileSheetComponent } from '../ddc-read-figure-mobile-sheet/ddc-read-figure-mobile-sheet.component'
import { DdcReadNoteMobileSheetComponent } from '../ddc-read-note-mobile-sheet/ddc-read-note-mobile-sheet.component'
import { DdcReadPairMobileSheetComponent } from '../ddc-read-pair-mobile-sheet/ddc-read-pair-mobile-sheet.component'
import { DdcReadQuizMobileSheetComponent } from '../ddc-read-quiz-mobile-sheet/ddc-read-quiz-mobile-sheet.component'
import { DdcReadWordMobileSheetComponent } from '../ddc-read-word-mobile-sheet/ddc-read-word-mobile-sheet.component'
import { DdcUpgradeMobileSheetComponent } from '../ddc-upgrade-mobile-sheet/ddc-upgrade-mobile-sheet.component'

@Component({
  selector: 'ddc-mobile-sheet',
  templateUrl: './ddc-mobile-sheet.component.html',
  styleUrls: ['./ddc-mobile-sheet.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    DdcAddMobileSheetComponent,
    DdcReadWordMobileSheetComponent,
    DdcReadNoteMobileSheetComponent,
    DdcReadPairMobileSheetComponent,
    DdcReadQuizMobileSheetComponent,
    DdcReadFigureMobileSheetComponent,
    DdcEditMobileSheetComponent,
    DdcFilterMobileSheetComponent,
    DdcUpgradeMobileSheetComponent,
    DdcGeneratePdfMobileSheetComponent,
    DdcAddDialogComponent,
    NodeConfigDialogComponent,
  ],
  animations: [
    trigger('slideUpDown', [
      state(
        'void',
        style({
          transform: 'translateY(100%)',
        }),
      ),
      state(
        'enter',
        style({
          transform: 'translateY(0)',
        }),
      ),
      state(
        'leave',
        style({
          transform: 'translateY(100%)',
        }),
      ),
      transition('void => enter', [animate('300ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
      transition('enter => leave', [animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
    ]),
  ],
})
export class DdcMobileSheetComponent {
  animationState: 'void' | 'enter' | 'leave' = 'enter'

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  constructor(
    public dialogRef: MatDialogRef<DdcMobileSheetComponent>,
    public themeService: ThemeService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }

  close(): void {
    this.animationState = 'leave'
    // Ensure we restore scrolling before closing the dialog
    document.body.style.overflow = ''
    setTimeout(() => {
      this.dialogRef.close()
    }, 200)
  }

  onConfigured(result: NodeConfigDialogResult): void {
    this.animationState = 'leave'
    document.body.style.overflow = ''
    setTimeout(() => {
      this.dialogRef.close(result)
    }, 200)
  }

  onCancelled(): void {
    this.close()
  }

  onAnimationStart(event: AnimationEvent): void {
    if (event.toState === 'enter') {
      document.body.style.overflow = 'hidden'
    }
  }

  onAnimationDone(event: AnimationEvent): void {
    if (event.toState === 'leave') {
      document.body.style.overflow = ''
    }
  }

  ngOnDestroy(): void {
    this.themeSubscription?.unsubscribe()
    // Ensure scroll is restored when component is destroyed
    document.body.style.overflow = ''
  }
}
